// // src/components/CurrencySelector.jsx
// import { useState, useEffect } from "react";
// import axios from "axios";
// import { Box, TextField, Autocomplete, InputAdornment, IconButton, CircularProgress, createFilterOptions, Button, } from "@mui/material";
// import { Search as SearchIcon } from "@mui/icons-material";
// import CurrencyMaster from "../Pages/CurrencyMaster";

// const noopFilter = createFilterOptions();

// export default function CurrencySelector({
//     apiBase,
//     value,
//     onChange,
//     exchangeRate,
//     onExchangeRateChange,
//     onAddCurrency,
//     setNewCurrency
// }) {
//     const [search, setSearch] = useState("");
//     const [results, setResults] = useState([]);
//     const [loading, setLoading] = useState(false);


//     // console.log("onAddCurrency" , onAddCurrency)

//     // Fetch currencies based on input
//     useEffect(() => {
//         if (!search.trim()) {
//             setResults([]);
//             return;
//         }

//         setLoading(true);
//         const id = setTimeout(async () => {
//             try {
//                 const res = await axios.get(`${apiBase}/api/currency-search`, {
//                     params: { search },
//                 });
//                 console.log("?? currency-search ?", res.data.data);
//                 setResults(res.data.data || []);
//             } catch (err) {
//                 console.error("currency-search error", err);
//                 setResults([]);
//             } finally {
//                 setLoading(false);
//             }
//         }, 400);

//         return () => clearTimeout(id);
//     }, [search, apiBase]);

//     // Allow only numbers with max 2 decimal places
//     const handleExchangeRateChange = (e) => {
//         const input = e.target.value;
//         const validPattern = /^\d*\.?\d{0,2}$/;
//         if (input === "" || validPattern.test(input)) {
//             onExchangeRateChange(input);
//         }
//     };

//     return (
//         <Box>
//             <Box
//                 sx={{
//                     display: "flex",
//                     flexWrap: "nowrap",
//                     alignItems: "center",
//                     gap: 2,
//                 }}
//             >
//                 {/* Currency Dropdown with fixed width */}
//                 <Box sx={{ minWidth: "157px" }}>
//                     <Autocomplete
//                         disablePortal
//                         options={results}
//                         filterOptions={noopFilter}
//                         getOptionLabel={(opt) => opt.CurrencyName}
//                         isOptionEqualToValue={(o, v) => o.currencyId === v.currencyId}
//                         value={value}
//                         loading={loading}
//                         noOptionsText={
//   search.trim() ? (
//     <Button
//       size="small"
//       variant="text"
//       onMouseDown={(e) => e.preventDefault()}
//       onClick={() => {onAddCurrency() ; 
//         if(setNewCurrency){
//             setNewCurrency(search)
//         }
//       }}
//     >
//       + Add currency
//     </Button>
//   ) : ""
// }
//                         inputValue={search}
//                         onChange={(_, v) => {
//                             onChange(v);
//                             setResults([]);
//                         }}
//                         onInputChange={(_, txt) => {
//                             setSearch(txt);
//                             if (!txt) onChange(null);
//                         }}
//                         renderInput={(params) => (
//                             <TextField
//                                 {...params}
//                                 label="Currency"
//                                 size="small"
//                                 fullWidth
//                                 InputProps={{
//                                     ...params.InputProps,
//                                 }}
//                             />
//                         )}
//                     />
//                 </Box>

//                 {/* Exchange Rate Field (visible only if currency selected) */}
//                 {value && (
//                     <Box sx={{ width: "157px" }}>
//                         <TextField
//                             label="Exchange Rate"
//                             size="small"
//                             fullWidth
//                             value={exchangeRate}
//                             onChange={handleExchangeRateChange}
//                             inputProps={{
//                                 inputMode: "decimal",
//                                 pattern: "^\\d*(\\.\\d{0,2})?$",
//                             }}
//                         />
//                     </Box>
//                 )}
//             </Box>
//         </Box>
//     );
// }




import { useState } from "react";
import {
    Box,
    TextField,
    Autocomplete,
    Button
} from "@mui/material";

export default function CurrencySelector({
    currencies = [],   // ✅ from parent
    value,
    onChange,
    exchangeRate,
    onExchangeRateChange,
    onAddCurrency,
    setNewCurrency,
    disabled = false
}) {
    const [search, setSearch] = useState("");

    // Allow only numbers with max 2 decimal places
    const handleExchangeRateChange = (e) => {
        const input = e.target.value;
        const validPattern = /^\d*\.?\d{0,2}$/;
        if (input === "" || validPattern.test(input)) {
            onExchangeRateChange(input);
        }
    };

    return (
        <Box>
            <Box
                sx={{
                    display: "flex",
                    flexWrap: "nowrap",
                    alignItems: "center",
                    gap: 1,
                }}
            >
                {/* Currency Dropdown */}
                <Box sx={{ width: value ? "50%" : "100%" }}>
                    <Autocomplete
                        sx={{
                            '& .MuiInputBase-root': {
                                height: 38,
                            }
                        }}
                        disabled={disabled}
                        disablePortal
                        options={currencies}   // ✅ use parent data
                        fullWidth
                        // ✅ filter locally (search)
                        filterOptions={(options, state) =>
                            options.filter((opt) =>
                                opt.CurrencyName?.toLowerCase().includes(
                                    state.inputValue.toLowerCase()
                                )
                            )
                        }

                        getOptionLabel={(opt) =>
                            opt?.CurrencyName
                                ? `${opt.CurrencyName}`
                                : ""
                        }

                        // ✅ FIXED (important)
                        isOptionEqualToValue={(o, v) =>
                            o?.CurrencyId === v?.CurrencyId
                        }

                        value={value || null}

                        inputValue={search}

                        onChange={(_, v) => {
                            onChange(v);
                        }}

                        onInputChange={(_, txt) => {
                            setSearch(txt);
                            if (!txt) onChange(null);
                        }}

                        noOptionsText="No options"
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Currency"
                                size="small"
                                fullWidth
                            />
                        )}
                    />
                </Box>

                {/* Exchange Rate Field */}
                {value && (
                    <Box sx={{ width: "50%" }}>
                        <TextField
                            label="Exchange Rate"
                            sx={{
                                '& .MuiInputBase-root': {
                                    height: 38,
                                }
                            }}
                            size="small"
                            fullWidth
                            value={exchangeRate}
                            onChange={handleExchangeRateChange}
                            inputProps={{
                                inputMode: "decimal",
                                pattern: "^\\d*(\\.\\d{0,2})?$",
                            }}
                            disabled={disabled}
                        />
                    </Box>
                )}
            </Box>
        </Box>
    );
}